import { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { usePermissions } from "../../hooks/usePermissions";
import { publicRuntimeConfig } from "../../config/publicRuntimeConfig";

/**
 * Debug component to show current user permissions
 * Only shows when ENABLE_PERMISSION_DEBUG=true
 */
export default function PermissionDebug() {
  const { user, isAuthenticated } = useAuth();
  const { hasPermission, permissions, roles } = usePermissions();
  const [isMinimized, setIsMinimized] = useState(true);

  // Only show when explicitly enabled
  if (!publicRuntimeConfig.permissionDebugEnabled) {
    return null;
  }

  if (isMinimized) {
    return (
      <button
        onClick={() => setIsMinimized(false)}
        style={{
          position: "fixed",
          bottom: "12px",
          right: "12px",
          background: "#1f2937",
          color: "#60a5fa",
          border: "none",
          padding: "8px 12px",
          fontSize: "14px",
          fontFamily: "monospace",
          cursor: "pointer",
          zIndex: 9999,
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        }}
        title="Show permission debug"
      >
        🔐
      </button>
    );
  }

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        right: 0,
        background: "#1f2937",
        color: "#fff",
        padding: "12px",
        fontSize: "11px",
        fontFamily: "monospace",
        maxWidth: "400px",
        maxHeight: "300px",
        overflow: "auto",
        zIndex: 9999,
        borderTopLeftRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "8px",
        }}
      >
        <strong style={{ color: "#60a5fa" }}>🔐 Permission Debug</strong>
        <button
          onClick={() => setIsMinimized(true)}
          style={{
            background: "transparent",
            border: "none",
            color: "#9ca3af",
            cursor: "pointer",
            fontSize: "16px",
            padding: "0 4px",
            lineHeight: 1,
          }}
          title="Minimize"
        >
          ✕
        </button>
      </div>
      <div style={{ marginBottom: "4px" }}>
        <strong>Auth:</strong> {isAuthenticated ? "✅ Logged in" : "❌ Not logged in"}
      </div>
      <div style={{ marginBottom: "4px" }}>
        <strong>User:</strong> {user?.email || "N/A"}
      </div>
      <div style={{ marginBottom: "4px" }}>
        <strong>Permissions:</strong> {permissions.length > 0 ? permissions.join(", ") : "❌ None"}
      </div>
      <div style={{ marginBottom: "4px" }}>
        <strong>Roles:</strong> {roles.length > 0 ? roles.map(r => r.key).join(", ") : "❌ None"}
      </div>
      <div
        style={{
          marginTop: "8px",
          paddingTop: "8px",
          borderTop: "1px solid #374151",
        }}
      >
        <div>taxonomy.read: {hasPermission("taxonomy.read") ? "✅" : "❌"}</div>
        <div>taxonomy.write: {hasPermission("taxonomy.write") ? "✅" : "❌"}</div>
        <div>taxonomy.delete: {hasPermission("taxonomy.delete") ? "✅" : "❌"}</div>
      </div>
    </div>
  );
}
